// Vegavruddhi brand green
export const BRAND = {
  primary: "#1a5c38",
  primaryMid: "#2d7a4f",
  primaryLight: "#e8f5ee",
  accent: "#f0a500",
};
